module.exports = __webpack_public_path__ + "static/logo3-df4fe3a727f9aee1da55d4d279158a58.png";